export default (value) => {
  if (value == null) {
    return value
  }

  const [hours, minutes] = value.split(':')
  return [hours, minutes].join(':')
}
